import {
  getIsFallingPriceFromTags,
  getIsFrozenPriceFromTags,
  getIsMadeInFranceFromTags,
  getIsOriginFranceFromTags,
  getIsUltraFresh,
} from '@monofront/business/utils';
import { useTranslations } from 'next-intl';
import BadgeMadeInFR from '../../../visuals/Icons/BadgeMadeInFR';
import BadgeOriginFR from '../../../visuals/Icons/BadgeOriginFR';
import BadgeFallingPrice from '../../../visuals/Icons/BadgeFallingPrice';
import BadgeFrozenPrice from '../../../visuals/Icons/BadgeFrozenPrice';
import { useProduct } from '../ProductCard';
import { IconSizes } from '../../../visuals/Icons/type';
import UltraFresh from '../../../visuals/Pictograms/UltraFresh';
import { useFormatAntiWasteTag } from '@monofront/business/hooks/product/useFormatAntiWasteTag';

export const ProductBadges = () => {
  const product = useProduct();
  const tCatalog = useTranslations('Catalog');
  const antiwasteTagTranslation = useFormatAntiWasteTag(product?.tags);

  if (!product) {
    return null;
  }

  const isMadeInFrance = getIsMadeInFranceFromTags(product.tags);
  const isFromFrance = getIsOriginFranceFromTags(product.tags);
  const isFallingPrice = getIsFallingPriceFromTags(product.tags);
  const isFrozenPrice = getIsFrozenPriceFromTags(product.tags);
  const isUltraFresh = getIsUltraFresh(product.tags);

  if (
    !(
      isMadeInFrance ||
      isFromFrance ||
      isFallingPrice ||
      isFrozenPrice ||
      isUltraFresh ||
      antiwasteTagTranslation
    )
  )
    return null;

  return (
    <div className="tw-absolute !tw-my-0 tw-flex tw-flex-col tw-items-start tw-space-y-1 tw-grid-area-[badges]">
      {isFromFrance && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative tw-lf-tag-decorative-blue">
          <BadgeOriginFR size={IconSizes.sm} aria-hidden="true" />
          {tCatalog('tagOriginFrance')}
        </p>
      )}
      {isMadeInFrance && !isFromFrance && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative tw-lf-tag-decorative-blue">
          <BadgeMadeInFR size={IconSizes.sm} aria-hidden="true" />
          {tCatalog('tagMadeInFrance')}
        </p>
      )}

      {isFallingPrice && !antiwasteTagTranslation && !isUltraFresh && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative-danger">
          <BadgeFallingPrice />
          {tCatalog('tagFallingPrice')}
        </p>
      )}
      {isFrozenPrice && !antiwasteTagTranslation && !isUltraFresh && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative-danger">
          <BadgeFrozenPrice />
          {tCatalog('tagFrozenPrice')}
        </p>
      )}
      {antiwasteTagTranslation && !isUltraFresh && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative-danger">
          {antiwasteTagTranslation}
        </p>
      )}
      {isUltraFresh && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative-blue-accent">
          <UltraFresh size={IconSizes.sm} />
          {product.shelf_life_at_reception && (
            <>
              {tCatalog('tagConsumptionLimit', {
                days: product.shelf_life_at_reception,
              })}
            </>
          )}
        </p>
      )}
    </div>
  );
};

export const HorizontalProductBadges = () => {
  const product = useProduct();
  const tCatalog = useTranslations('Catalog');
  const antiwasteTagTranslation = useFormatAntiWasteTag(product?.tags);

  if (!product) {
    return null;
  }

  const isMadeInFrance = getIsMadeInFranceFromTags(product.tags);
  const isFromFrance = getIsOriginFranceFromTags(product.tags);
  const isFallingPrice = getIsFallingPriceFromTags(product.tags);
  const isFrozenPrice = getIsFrozenPriceFromTags(product.tags);
  const isUltraFresh = getIsUltraFresh(product.tags);

  if (
    !isFallingPrice &&
    !isFromFrance &&
    !isMadeInFrance &&
    !isFrozenPrice &&
    !isUltraFresh &&
    !antiwasteTagTranslation
  ) {
    return null;
  }

  return (
    <div className="tw-flex tw-flex-col tw-items-start tw-gap-x-2 tw-space-y-1 tw-grid-area-[badges] phone:tw-flex-row phone:tw-space-y-0">
      {isFromFrance && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative tw-lf-tag-decorative-blue">
          <BadgeOriginFR size={IconSizes.sm} aria-hidden="true" />
          {tCatalog('tagOriginFrance')}
        </p>
      )}
      {isMadeInFrance && !isFromFrance && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative tw-lf-tag-decorative-blue">
          <BadgeMadeInFR size={IconSizes.sm} aria-hidden="true" />
          {tCatalog('tagMadeInFrance')}
        </p>
      )}

      {isFallingPrice && !antiwasteTagTranslation && !isUltraFresh && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative-danger">
          <BadgeFallingPrice />
          {tCatalog('tagFallingPrice')}
        </p>
      )}
      {isFrozenPrice && !antiwasteTagTranslation && !isUltraFresh && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative-danger">
          <BadgeFrozenPrice />
          {tCatalog('tagFrozenPrice')}
        </p>
      )}
      {antiwasteTagTranslation && !isUltraFresh && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative-danger">
          {antiwasteTagTranslation}
        </p>
      )}
      {isUltraFresh && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative-blue-accent">
          <UltraFresh size={IconSizes.sm} />
          {product.shelf_life_at_reception && (
            <>
              {tCatalog('tagConsumptionLimit', {
                days: product.shelf_life_at_reception,
              })}
            </>
          )}
        </p>
      )}
    </div>
  );
};

export const HorizontalSearchProductBadges = () => {
  const product = useProduct();
  const tCatalog = useTranslations('Catalog');
  const antiwasteTagTranslation = useFormatAntiWasteTag(product?.tags);

  if (!product) {
    return null;
  }

  const isMadeInFrance = getIsMadeInFranceFromTags(product.tags);
  const isFromFrance = getIsOriginFranceFromTags(product.tags);
  const isFallingPrice = getIsFallingPriceFromTags(product.tags);
  const isFrozenPrice = getIsFrozenPriceFromTags(product.tags);
  const isUltraFresh = getIsUltraFresh(product.tags);

  if (
    !isFallingPrice &&
    !isFromFrance &&
    !isMadeInFrance &&
    !isFrozenPrice &&
    !isUltraFresh &&
    !antiwasteTagTranslation
  ) {
    return null;
  }

  return (
    <div className="tw-items-start tw-space-y-1 tw-grid-area-[badges] phone:tw-flex phone:tw-space-x-2 phone:tw-space-y-0">
      {isFromFrance && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative tw-lf-tag-decorative-blue">
          <BadgeOriginFR size={IconSizes.sm} aria-hidden="true" />
          {tCatalog('tagOriginFrance')}
        </p>
      )}
      {isMadeInFrance && !isFromFrance && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative tw-lf-tag-decorative-blue">
          <BadgeMadeInFR size={IconSizes.sm} aria-hidden="true" />
          {tCatalog('tagMadeInFrance')}
        </p>
      )}

      {isFallingPrice && !antiwasteTagTranslation && !isUltraFresh && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative-danger">
          <BadgeFallingPrice />
          {tCatalog('tagFallingPrice')}
        </p>
      )}
      {isFrozenPrice && !antiwasteTagTranslation && !isUltraFresh && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative-danger">
          <BadgeFrozenPrice />
          {tCatalog('tagFrozenPrice')}
        </p>
      )}
      {antiwasteTagTranslation && !isUltraFresh && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative-danger">
          {antiwasteTagTranslation}
        </p>
      )}
      {isUltraFresh && (
        <p className="tw-lf-tag tw-lf-tag-sm tw-lf-tag-decorative-blue-accent">
          <UltraFresh size={IconSizes.sm} />
          {product.shelf_life_at_reception && (
            <>
              {tCatalog('tagConsumptionLimit', {
                days: product.shelf_life_at_reception,
              })}
            </>
          )}
        </p>
      )}
    </div>
  );
};
